import React from 'react'
import Navbar from './F.Pages/Nav/Nav'
import Header from './F.Pages/Header/Header'
import Body from './F.Pages/Body/Body'
import Display from './F.Pages/Display/Display'
import Final from './F.Pages/Final/Final'
import Footer from './F.Pages/Footer/Footer'

function View() {
  return (
    <div>
      <Navbar />
      <Header />
      <Body />
      <Display />
      <Final />
      <Footer />
    </div>
  )
}

export default View
